// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: 'https://ezorderapi.estatic-infotech.com/',
  allowFileExtension: ['pdf', 'doc', 'docx', 'xls', 'xlsx'],
  allowExtesions: ['pdf', 'doc', 'docx'],
  maximumFileSize: 104857600,
  imageUrl: 'https://ezorderstoragepreprod.blob.core.windows.net/',
  stripePublishableKey:
    'pk_test_51Ng5nHLtACJWkWg5uCHphjTCQwfwtlBglGLZwWPfH3n7AdkSGiwhAXmtVhwho52C2zj9GBdBDz1VKkIVwsBFrSi6008QioCr48',
  stripeSecretkey:
    'sk_test_51Ng5nHLtACJWkWg5UCg3EKZvFVFtXOoE8s0rblKf2SqX4cvj8gzngW6IMmsKedTKfWbY7R3R5ZfD5kyUhx7u3EDZ00eVQff4Sm',
  // stripePublishableKey: "pk_test_ms7ch53hwLcJqeIqbQxrkbiq",
  // stripeSecretkey: "sk_test_70eUVX2x7PNtrmeLX4yrZQwK"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
